// extracted by mini-css-extract-plugin
export default {"flag":"flag_flag__STDKW"};